<!-- Navigation -->
<treo-vertical-navigation class="theme-dark"
                          [appearance]="navigationAppearance"
                          [mode]="isScreenSmall ? 'over' : 'side'"
                          [name]="'mainNavigation'"
                          [navigation]="menuData"
                          [opened]="!isScreenSmall">

    <div treoVerticalNavigationContentHeader>
        <div class="logo">
            <img src="assets/images/logo/logo.svg">
        </div>
    </div>

</treo-vertical-navigation>

<!-- Wrapper -->
<div class="wrapper">

    <!-- Header -->
    <div class="header">



        <!-- Navigation appearance toggle button -->
        <button class="navigation-appearance-toggle-button"
                [ngClass]="{mirror: navigationAppearance === 'dense'}"
                mat-icon-button
                (click)="toggleNavigationAppearance()">
            <mat-icon [svgIcon]="'menu_open'"></mat-icon>
        </button>


        <fx-tab-bar></fx-tab-bar>
        <!-- Spacer -->
        <div class="spacer"></div>


        <!-- User -->
        <user [user]="session.user"></user>

    </div>

    <!-- Content -->
    <div class="content">

        <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
             it won't register the changes on the layout and won't update the view. -->
        <router-outlet *ngIf="true"></router-outlet>

    </div>

    <!-- Footer -->
    <!-- <div class="footer">
        Treo &copy; {{currentYear}}
    </div> -->

</div>
